module.exports = __webpack_public_path__ + "static/media/search-img.b1fcf823.svg";